import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { fetchData } from "../../../utility/adminApi.js";
import { useQuery } from "@tanstack/react-query";
import { formatDateTime } from "../../../components/formatDateTime.js";
import loader from "../../../assets/loader.webp";
import LoanView from "./LoanView.jsx";

const Pending = () => {
  const { data: pendingLoan, isPending } = useQuery({
    queryKey: ["pendingLoan"],
    queryFn: () => fetchData("loans/pending"), // Call manually
    staleTime: 1000 * 60 * 50, // Keep fresh for 50 minutes
    cacheTime: 1000 * 60 * 60, // Cache for 60 minutes
    retry: 1,
    keepPreviousData: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  if (isPending)
    return (
      <div className="flex justify-center items-center">
        {" "}
        <img src={loader} alt="loading state" className="h-12 w-12" />
      </div>
    );

  return (
    <div className="">
      {/* Search Bar */}
      <div className="mt-4">
        <input
          type="text"
          placeholder="Search by name"
          className="w-full border rounded-md p-2 text-sm"
        />
      </div>

      {/* Table */}
      <div className="overflow-x-auto mt-4">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-gray-100 text-gray-600">
            <tr>
              <th className="py-2 px-4">Loan ID</th>
              <th className="py-2 px-4">Loan amount</th>
              <th className="py-2 px-4">Repayment amount</th>
              <th className="py-2 px-4">Date applied</th>
              <th className="py-2 px-4">Repayment date</th>
              <th className="py-2 px-4">Status</th>
              <th className="py-2 px-4">Actions</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {pendingLoan?.data?.data?.map(
              (
                loan,
                idx //pendingLoan?.data?.data?
              ) => (
                <tr key={idx} className="border-b hover:bg-gray-50">
                  <td className="py-2 px-4">{loan?.loanNO}</td>
                  <td className="py-2 px-4">{loan?.loan_amount}</td>
                  <td className="py-2 px-4">{loan?.repayment_amount}</td>
                  <td className="py-2 px-4">
                    {formatDateTime(loan?.updated_at)}
                  </td>
                  <td className="py-2 px-4">
                    {formatDateTime(loan?.repayment_date)}
                  </td>
                  <td className="py-2 px-4">
                    {" "}
                    <span className="h-2 w-2 rounded-full bg-orange-400"></span>
                    {loan?.status}
                  </td>

                  <td className="py-2 px-4 text-center">
                    <LoanView />
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Pending;
